import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Container from '@mui/material/Container';
import MKBox from 'components/MaterialKit/MKBox';
import { handleErrorResponse } from 'utils/general';
import { useAuth } from 'contexts/auth';
import { createDynamicTableRow, getDynamicTableRow, updateDynamicTableRow } from 'api/sections';
import { LANGUAGE_COLLECTION_DEFINITION_ID } from 'pages/AppSummary/LanguageSection';
import { getCollectionDefinition } from 'api/collection_definitions';
import { getDynamicData } from 'utils/sections';
import EditLanguageForm from './EditLanguageForm';

const EditLanguagePage = () => {
  const [languageAttributes, setLanguageAttributes] = useState();
  const [languageData, setLanguageData] = useState();
  const { languageId } = useParams();
  const navigate = useNavigate();
  const { setAuth } = useAuth();

  const fetchLanguageFromApi = useCallback(() => {
    const collectionDefinitionParams = {
      $expand: 'attributes',
    };
    return getCollectionDefinition(LANGUAGE_COLLECTION_DEFINITION_ID, collectionDefinitionParams)
      .then((res) => {
        const collectionDefinition = res.data;
        const { attributes } = collectionDefinition;
        setLanguageAttributes(attributes);
        if (languageId) {
          return getDynamicTableRow(LANGUAGE_COLLECTION_DEFINITION_ID, languageId)
            .then(({ data }) => {
              const dynamicFieldValueData = {
                ...getDynamicData(data, attributes),
                ...data,
              };
              setLanguageData(dynamicFieldValueData);
            })
            .catch((err) => {
              handleErrorResponse(err, setAuth);
            });
        }
      })
      .catch((err) => {
        handleErrorResponse(err, setAuth);
      });
  }, [languageId, setAuth]);

  const onClickCancel = useCallback(() => {
    return navigate(-1);
  }, [navigate]);

  const onClickSaveToApi = useCallback((values) => {
    const mappedValue = {};
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const property in values) {
      let targetAttributeId;
      languageAttributes.forEach((attribute) => {
        if (attribute.name === property) {
          targetAttributeId = attribute.attribute_id;
        }
      });
      mappedValue[targetAttributeId] = values[property];
    }
    const body = {
      json_short_data: JSON.stringify(mappedValue),
    };

    let promise;
    if (languageId) {
      promise = updateDynamicTableRow(LANGUAGE_COLLECTION_DEFINITION_ID, languageId, body);
    } else {
      promise = createDynamicTableRow(LANGUAGE_COLLECTION_DEFINITION_ID, body);
    }
    Promise.resolve(promise)
      .then(() => {
        navigate(-1);
      })
      .catch((err) => {
        handleErrorResponse(err, setAuth);
      });
  }, [languageAttributes, languageId, navigate, setAuth]);

  useEffect(() => {
    fetchLanguageFromApi();
  }, [fetchLanguageFromApi]);

  return (
    <MKBox flex={1} bgColor="light" py="2rem">
      <Container>
        <EditLanguageForm
          language={languageData}
          onSave={onClickSaveToApi}
          onCancel={onClickCancel}
        />
      </Container>
    </MKBox>
  );
};

export default EditLanguagePage;
